import React from 'react';
import { Provider } from 'react-redux';
import { configureStore } from 'redux/store';

export const ProviderWrapper = ({ children }) => {
  const store = configureStore();

  return <Provider store={store}>{children}</Provider>;
};
